(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/helpers/activation-handler.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/helpers/activation-handler.js');
'use strict';

const _svs$arena$service$te = svs.arena.service.teamsService,
  getRequestsAsync = _svs$arena$service$te.getRequestsAsync,
  putActivateMemberAsync = _svs$arena$service$te.putActivateMemberAsync,
  deleteRequestAsync = _svs$arena$service$te.deleteRequestAsync;
const changeMemberActivity = svs.arena.store.teams.actions.changeMemberActivity;
const _svs$arena$pages$team = svs.arena.pages.teams.dialogs,
  showActivationDialog = _svs$arena$pages$team.showActivationDialog,
  showTechnicalError = _svs$arena$pages$team.showTechnicalError;
const activationHandler = async dispatch => {
  const _await$getRequestsAsy = await getRequestsAsync(),
    data = _await$getRequestsAsy.data,
    error = _await$getRequestsAsy.error;
  if (error) {
    svs.arena.logger.warn('Could not get requests', error);
  } else {
    data.customerRequests.forEach(async request => {
      const teamId = request.referenceId;
      const customerId = request.issuedById;
      const syndicateName = request.syndicateName;
      const memberName = request.issuedBy;
      const activation = await showActivationDialog(memberName, syndicateName);
      if (activation) {
        const _await$putActivateMem = await putActivateMemberAsync(customerId, teamId),
          error = _await$putActivateMem.error;
        if (error) {
          if (error.code === '22 108') {
            dispatch(changeMemberActivity({
              teamId,
              customerId,
              active: true
            }));
          } else {
            svs.arena.logger.warn('Could not activate member', error);
            showTechnicalError();
          }
        } else {
          dispatch(changeMemberActivity({
            teamId,
            customerId,
            active: true
          }));
        }
      } else {
        const _await$deleteRequestA = await deleteRequestAsync(customerId, teamId),
          error = _await$deleteRequestA.error;
        if (error) {
          svs.arena.logger.warn('Could not delete request', error);
          showTechnicalError();
        }
      }
    });
  }
};
svs.arena.pages.teams.activationHandler = activationHandler;

 })(window);